export const environment = {
    production: false,
    firebaseConfig: {
        apiKey: "AIzaSyDUCna7SOAKXvmTbC9FJUHobuV9KwYSbao",
        authDomain: "agromet-web.firebaseapp.com",
        projectId: "agromet-web",
        storageBucket: "agromet-web.firebasestorage.app",
        messagingSenderId: "788874708992",
        appId: "1:788874708992:web:de1c63126f6a8167b870e5",
        measurementId: "G-BMJTXG3TDC"
    }
  };